export class AuditFilter {
    type!: string;
    action!: string;
    userId!: string;
    projectId!: string;
    groupRoleId!: string;
    createdBy!: string; //creator_Id
    startTime!: string;
    endTime!: string;
}

export class AuditDto {
    id!: string;
    type!: string;
    action!: string;
    groupRoleId!: string;
    groupRoleName!: string;
    projectId!: string;
    projectName!: string;
    creatorId!: string;
    creatorName!: string;
    createdWhen!: string;
    userId!: string;
    userEmail!: string;
    userName!: string;
    actPermissions!: string;
    prevPermissions!: string;
}